import {OptionsObject, SnackbarMessage, useSnackbar, WithSnackbarProps} from "notistack";
import React from "react";

// Source: https://github.com/iamhosseindhv/notistack/issues/30

let useSnackbarRef: WithSnackbarProps;
export const SnackbarUtilsConfigurator: React.FC = () => {
    useSnackbarRef = useSnackbar();
    return null;
};

const api = {
    success(msg: string, options: OptionsObject = {}) {
        this.toast(msg, {...options, variant: "success"});
    },
    warning(msg: string, options: OptionsObject = {}) {
        this.toast(msg, {...options, variant: "warning"});
    },
    info(msg: string, options: OptionsObject = {}) {
        this.toast(msg, {...options, variant: "info"});
    },
    error(msg: SnackbarMessage, options: OptionsObject = {}) {
        this.toast(msg, {...options, variant: "error"});
    },
    toast(msg: SnackbarMessage, options: OptionsObject = {}) {
        useSnackbarRef.enqueueSnackbar(msg, options);
    },
};

export default api;
